<div style="background: black;" class="login-wrapper">
  <div *ngIf="!loading" class="cue-logo">
    <img src="assets/app/media/img/users/cueaudio_logo.jpg">
  </div>

  <ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

  <div class="login-card" *ngIf="!loading" [hidden]="loginMode !== loginModeType.Portal">

    <div class="login-header">
      <h3 class="login-card__title">Customer Portal Login</h3>
    </div>

    <div class="border-line"></div>

    <form [formGroup]="portalLoginForm" class="m-login__form m-form" *ngIf="portalLoginForm">

      <div class="login-card__field">
        <input 
          type="text" 
          class="login-card__input"
           maxlength="256" 
           [ignoreWhiteSpace]
           placeholder="Email" 
           formControlName="email"
           name="email" required>
      </div>

      <div class="login-card__field" style="margin-bottom: 10px;">
        <input 
          type="password"
          placeholder="Password" 
          class="login-card__input" 
          maxlength="256"
          [ignoreWhiteSpace]
          formControlName="password" 
          name="password" required>
      </div>

      <div class="help" style="color:lightgrey">
        <span>
          <span>Firefox or Safari is recommended</span>
        </span>
      </div>

      <div class="row m-login__form-sub">
        <div class="col m--align-right">
          <a href="javascript:;" id="m_login_forget_password" class="login-card__forgot-password__link"
            (click)="loginMode = loginModeType.ForgotPassword;">
            Forgot Password?
          </a>
        </div>
      </div>

      <button type="submit" [debounceClick] (click)="login()" class="login-card__login__button" style="margin-bottom: 10px;">Login</button>

      <div class="border-line" style="margin-bottom: 15px;"></div>

      <div class="help" style="margin-bottom: 10px;">
        <span>
          Looking for the 
        </span>
        <a href="#" (click)="merchantNav()" class="login-card__forgot-password__link">
          Merchant Portal?
        </a>
      </div>
    </form>

    <div class="help">
      <span>
        Interested in partnering with us? 
      </span>
    </div>

    <div class="help" style="margin-bottom: 10px;">
      <a class="login-card__access__link" href="https://cueaudio.com/contact-us/">Request Access Here</a>
    </div>

      <div class="help">
        <span>
          Still need help?
        </span>
        <a href="mailto:support@connectwithcue.com" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

  </div> <!-- portal login card -->

  <div class="login-card" *ngIf="!loading" [hidden]="loginMode !== loginModeType.ForgotPassword">

    <div class="login-header">
      <h3 class="login-card__title">Password Reset</h3>
    </div>

    <div class="border-line"></div>

    <form [formGroup]="forgotPasswordForm" class="m-login__form m-form" *ngIf="forgotPasswordForm">

      <div *ngIf="!forgotPasswordSubmitted"> 
        <div class="login-card__field">
          <input 
            type="text" 
            class="login-card__input"
            maxlength="256" 
            [ignoreWhiteSpace]
            placeholder="Email" 
            formControlName="email"
            name="email" required>
        </div>

        <button type="submit" [debounceClick] (click)="forgotPassword()" class="login-card__login__button" style="margin-bottom: 10px; margin-top: 30px" [disabled]="!forgotPasswordForm.valid">Submit</button>

      </div>

        <div *ngIf="forgotPasswordSubmitted" class="help" style="margin-bottom: 10px; margin-top: 20px;">
          <span>Your password reset link was successfully sent to {{forgotPasswordForm.controls.email.value}}. Please follow the link to reset your password. </span>
      </div>

      <div class="border-line" style="margin-bottom: 15px;"></div>

      <div class="help" style="margin-bottom: 10px;">
        <a href="#" (click)="loginMode = loginModeType.Portal" class="login-card__forgot-password__link">
          Back to Customer Login
        </a>
      </div>
    </form>

      <div class="help">
        <span>
          Need help?
        </span>
        <a href="mailto:support@connectwithcue.com" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

  </div> <!-- portal login card -->

  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.StripeSuccess">

    <div class="login-header" style="margin-bottom: 10px;">
      <h3 class="login-card__title">Fundraising Account Setup Complete!</h3>
    </div>

    <div class="border-line"></div>

    <div class="help" style="margin-bottom: 10px; margin-top: 20px;">
      <span>You are now ready to start fundrasing! Thanks again for choosing to partner with CUE Audio.</span>
    </div>

    <div class="help" style="margin-bottom: 10px;">
      
      <a href="#" (click)="portalNav()" class="login-card__forgot-password__link">
        Click here
      </a>
      <span>
        to login to the Customer Portal 
      </span>
    </div>

    <div class="border-line" style="margin-bottom: 20px;"></div>

    <div class="help">
      <span>
        Need help?
      </span>
      <a href="https://www.cueaudio.com/contact" class="login-card__forgot-password__link">
        Contact CUE Support
      </a>
    </div>

  </div> <!-- portal login card -->


  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.StripeFailure">

    <div class="login-header" style="margin-bottom: 10px;">
      <h3 class="login-card__title">Looks like Stripe was unable to complete your account setup...</h3>
    </div>

    <div class="border-line"></div>

    <div class="help" style="margin-bottom: 10px; margin-top: 20px;">
      <span>Something went wrong during Stripe's account registration process. We apologize for any inconvenience. Please contact us at </span>
      <a href="mailto:support@connectwithcue.com">
        support@connectwithcue.com
      </a>
    </div>

    <div class="help" style="margin-bottom: 10px;">
      
      <a href="#" (click)="portalNav()" class="login-card__forgot-password__link">
        Click here
      </a>
      <span>
        to return to the Customer Portal 
      </span>
    </div>

    <div class="border-line" style="margin-bottom: 20px;"></div>


  </div> <!-- merchant login card -->

  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.Onboarding">

    <div class="login-header">
      <h3 class="login-card__title">Create Your Customer Portal Account</h3>
    </div>

    <form [formGroup]="portalRegisterForm" class="m-login__form m-form" *ngIf="portalRegisterForm">

      <div class="login-card__field">
        <input 
          type="text" 
          class="login-card__input" 
          maxlength="256" 
          [ignoreWhiteSpace]
          placeholder="Confirm Email" 
          formControlName="email"
          name="email" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Password"
          class="login-card__input" 
          maxlength="24"
          [ignoreWhiteSpace]
          formControlName="newPassword1"
          name="newPassword1" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Retype Password" 
          class="login-card__input" 
          maxlength="24" 
          [ignoreWhiteSpace]
          formControlName="newPassword2"
          name="newPassword2" required>
      </div>

      <div 
        class="help" 
        style="margin-bottom: 10px; color: red;" 
        *ngIf="!portalRegisterForm.controls.email.valid 
          && portalRegisterForm.controls.email.dirty 
          && portalRegisterForm.controls.email.touched" >
        <span>
          <span>Invalid email address</span>
        </span>
      </div>

      <div class="help" 
      *ngIf="portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value 
        && portalRegisterForm.controls.newPassword2.dirty 
        && portalRegisterForm.controls.newPassword2.touched" 
        style="margin-bottom: 10px; color: red;" >
        <span>
          <span>The passwords need to match</span>
        </span>
      </div>

      <div class="help" style="margin-bottom: 30px;" 
      [ngStyle]="{'color': !portalRegisterForm.controls.newPassword1.valid 
        && portalRegisterForm.controls.newPassword1.dirty 
        && portalRegisterForm.controls.newPassword1.touched ? 'red' : 'black'}">
        <span>
          <span>Your password must be between 8 and 24 characters, and contain at least one symbol and one number</span>
        </span>
      </div>

      <button type="submit" [debounceClick] (click)="submitPortalRegistration()" class="login-card__login__button" style="margin-bottom: 30px;" [disabled]="!portalRegisterForm.valid || portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value">Register</button>


    </form>

      <div class="help">
        <span>
          Need help?
        </span>
        <a href="https://www.cueaudio.com/contact" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

      


  </div> <!-- portal login card -->

  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.VendorUserOnboarding">

    <div class="login-header">
      <h3 class="login-card__title">Create Your Fundraising Portal Account</h3>
    </div>

    <form [formGroup]="portalRegisterForm" class="m-login__form m-form" *ngIf="portalRegisterForm">

      <div class="login-card__field">
        <input 
          type="text" 
          class="login-card__input" 
          maxlength="256" 
          [ignoreWhiteSpace]
          placeholder="Confirm Email" 
          formControlName="email"
          name="email" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Password"
          class="login-card__input" 
          maxlength="24"
          [ignoreWhiteSpace]
          formControlName="newPassword1"
          name="newPassword1" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Retype Password" 
          class="login-card__input" 
          maxlength="24" 
          [ignoreWhiteSpace]
          formControlName="newPassword2"
          name="newPassword2" required>
      </div>

      <div 
        class="help" 
        style="margin-bottom: 10px; color: red;" 
        *ngIf="!portalRegisterForm.controls.email.valid 
          && portalRegisterForm.controls.email.dirty 
          && portalRegisterForm.controls.email.touched" >
        <span>
          <span>Invalid email address</span>
        </span>
      </div>

      <div class="help" 
      *ngIf="portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value 
        && portalRegisterForm.controls.newPassword2.dirty 
        && portalRegisterForm.controls.newPassword2.touched" 
        style="margin-bottom: 10px; color: red;" >
        <span>
          <span>The passwords need to match</span>
        </span>
      </div>

      <div class="help" style="margin-bottom: 30px;" 
      [ngStyle]="{'color': !portalRegisterForm.controls.newPassword1.valid 
        && portalRegisterForm.controls.newPassword1.dirty 
        && portalRegisterForm.controls.newPassword1.touched ? 'red' : 'black'}">
        <span>
          <span>Your password must be between 8 and 24 characters, and contain at least one symbol and one number</span>
        </span>
      </div>

      <button type="submit" [debounceClick] (click)="submitVendorUserRegistration()" class="login-card__login__button" style="margin-bottom: 30px;" [disabled]="!portalRegisterForm.valid || portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value">Register</button>


    </form>

      <div class="help">
        <span>
          Need help?
        </span>
        <a href="https://www.cueaudio.com/contact" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

      


  </div> <!-- portal login card -->

  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.OperatorOnboarding">

    <div class="login-header">
      <h3 class="login-card__title">Create Your Operator Account</h3>
    </div>

    <form [formGroup]="portalRegisterForm" class="m-login__form m-form" *ngIf="portalRegisterForm">

      <div class="login-card__field">
        <input 
          type="text" 
          class="login-card__input" 
          maxlength="256" 
          [ignoreWhiteSpace]
          placeholder="Confirm Email" 
          formControlName="email"
          name="email" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Password"
          class="login-card__input" 
          maxlength="24"
          [ignoreWhiteSpace]
          formControlName="newPassword1"
          name="newPassword1" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Retype Password" 
          class="login-card__input" 
          maxlength="24" 
          [ignoreWhiteSpace]
          formControlName="newPassword2"
          name="newPassword2" required>
      </div>

      <div 
        class="help" 
        style="margin-bottom: 10px; color: red;" 
        *ngIf="!portalRegisterForm.controls.email.valid 
          && portalRegisterForm.controls.email.dirty 
          && portalRegisterForm.controls.email.touched" >
        <span>
          <span>Invalid email address</span>
        </span>
      </div>

      <div class="help" 
      *ngIf="portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value 
        && portalRegisterForm.controls.newPassword2.dirty 
        && portalRegisterForm.controls.newPassword2.touched" 
        style="margin-bottom: 10px; color: red;" >
        <span>
          <span>The passwords need to match</span>
        </span>
      </div>

      <div class="help" style="margin-bottom: 30px;" 
      [ngStyle]="{'color': !portalRegisterForm.controls.newPassword1.valid 
        && portalRegisterForm.controls.newPassword1.dirty 
        && portalRegisterForm.controls.newPassword1.touched ? 'red' : 'black'}">
        <span>
          <span>Your password must be between 8 and 24 characters, and contain at least one symbol and one number</span>
        </span>
      </div>

      <button type="submit" [debounceClick] (click)="submitOperatorRegistration()" class="login-card__login__button" style="margin-bottom: 30px;" [disabled]="!portalRegisterForm.valid || portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value">Register</button>

    </form>
      <div class="help">
        <span>
          Need help?
        </span>
        <a href="https://www.cueaudio.com/contact" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

  </div> <!-- operator onboarding card -->

  <div class="login-card" *ngIf="!loading && loginMode === loginModeType.ResetPassword">

    <div class="login-header">
      <h3 class="login-card__title">Reset Your Account Password</h3>
    </div>

    <form [formGroup]="portalRegisterForm" class="m-login__form m-form" *ngIf="portalRegisterForm">

      <div class="login-card__field">
        <input 
          type="text" 
          class="login-card__input" 
          maxlength="256" 
          [ignoreWhiteSpace]
          placeholder="Confirm Email" 
          formControlName="email"
          name="email" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Password"
          class="login-card__input" 
          maxlength="24"
          [ignoreWhiteSpace]
          formControlName="newPassword1"
          name="newPassword1" required>
      </div>

      <div class="login-card__field">
        <input 
          type="password" 
          placeholder="Retype Password" 
          class="login-card__input" 
          maxlength="24" 
          [ignoreWhiteSpace]
          formControlName="newPassword2"
          name="newPassword2" required>
      </div>

      <div 
        class="help" 
        style="margin-bottom: 10px; color: red;" 
        *ngIf="!portalRegisterForm.controls.email.valid 
          && portalRegisterForm.controls.email.dirty 
          && portalRegisterForm.controls.email.touched" >
        <span>
          <span>Invalid email address</span>
        </span>
      </div>

      <div class="help" 
      *ngIf="portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value 
        && portalRegisterForm.controls.newPassword2.dirty 
        && portalRegisterForm.controls.newPassword2.touched" 
        style="margin-bottom: 10px; color: red;" >
        <span>
          <span>The passwords need to match</span>
        </span>
      </div>

      <div class="help" style="margin-bottom: 30px;" 
      [ngStyle]="{'color': !portalRegisterForm.controls.newPassword1.valid 
        && portalRegisterForm.controls.newPassword1.dirty 
        && portalRegisterForm.controls.newPassword1.touched ? 'red' : 'black'}">
        <span>
          <span>Your password must be between 8 and 24 characters, and contain at least one symbol and one number</span>
        </span>
      </div>

      <button type="submit" [debounceClick] (click)="resetPassword()" class="login-card__login__button" style="margin-bottom: 30px;" [disabled]="!portalRegisterForm.valid || portalRegisterForm.controls.newPassword1.value != portalRegisterForm.controls.newPassword2.value">Reset</button>


    </form>

      <div class="help">
        <span>
          Need help?
        </span>
        <a href="https://www.cueaudio.com/contact" class="login-card__support__link">
          Contact CUE Support
        </a>
      </div>

      


  </div> <!-- merchant login card -->

</div>

